import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/*
  Generated class for the Thankyou page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-thankyou',
  templateUrl: 'thankyou.html'
})
export class ThankYouPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad ThankYouPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/thankyou/thankyou.ts